var map = {
	"./customer/store.js": "53ad",
	"./product/store.js": "edea",
	"./quotation/store.js": "38a8",
	"./sample/store.js": "bb31",
	"./service/store.js": "901f",
	"./settings/store.js": "dd3c",
	"./user/store.js": "1053"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fcda";